import { Navigate } from 'react-router-dom';
import { useState } from 'react';

import { useLeague } from '../../hooks';
import { ROUTES } from '../../routes';

import { History } from 'lucide-react';

import {
  CardDisplay,
  SelectionStatus,
  PurchaseSection,
  TokenSelector,
  WinnersHistory,
  SeasonTimer,
  CurrentPrizePool,
  Bonus2x1,
} from '../../components';

export const JadeiteImperial = () => {
  const { league, currentSeason, loading } = useLeague();

  const [showMySelections, setShowMySelections] = useState(false);
  const [selectedTokens, setSelectedTokens] = useState<number[]>([]);
  const [cardsOwned, setCardsOwned] = useState(0);
  const [cardsUsed, setCardsUsed] = useState(0);

  if (loading) return null;

  if (!league) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  const totalCards = cardsOwned;
  const availableCards = totalCards - cardsUsed;

  return (
      <div className="isg-league-container">
        <SeasonTimer />
        <CurrentPrizePool />
  
        <Bonus2x1 />
  
        <div className="isg-league-grid">
          <div className="isg-league-left">
            <CardDisplay />
  
            <SelectionStatus
              used={cardsUsed}
              total={totalCards}
              available={availableCards}
            />
  
            <button
              onClick={() => setShowMySelections((v) => !v)}
              className="isg-league-button"
              style={{
                backgroundColor: currentSeason?.bgColor,
                color: currentSeason?.color,
              }}
            >
              <History className="isg-league-button-icon" />
              {showMySelections ? 'Ocultar' : 'Ver'} Mis Selecciones
            </button>
  
            {showMySelections && (
              <div
                className="isg-league-selections-box"
                style={{
                  borderColor: currentSeason?.bgColor,
                  background: `${currentSeason?.bgColor}10`,
                }}
              >
                <h3
                  className="isg-league-selections-title"
                  style={{ color: currentSeason?.color }}
                >
                  Tokens seleccionados
                </h3>
  
                {selectedTokens.length === 0 ? (
                  <p className="isg-league-empty">
                    Aún no has seleccionado ningún token
                  </p>
                ) : (
                  <div className="isg-league-tokens">
                    {selectedTokens.map((token) => (
                      <span
                        key={token}
                        className="isg-league-token"
                        style={{
                          backgroundColor: currentSeason?.bgColor,
                          color: currentSeason?.color,
                        }}
                      >
                        #{token}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
  
          <div className="isg-league-right">
            <PurchaseSection
              onPurchase={(quantity: number) => {
                setCardsOwned((prev) => prev + quantity);
              }}
            />
  
            <TokenSelector
              maxTokens={20000}
              selectedTokens={selectedTokens}
              availableSelections={availableCards - selectedTokens.length}
              onSelectToken={(token: number) => {
                if (availableCards > selectedTokens.length) {
                  setSelectedTokens((prev) => [...prev, token]);
                  setCardsUsed((prev) => prev + 1);
                }
              }}
            />
          </div>
        </div>
  
        <WinnersHistory />
      </div>
    );
};
